import {MatGoogleMapsAutocompleteModule} from "@angular-material-extensions/google-maps-autocomplete";
import {provideHttpClient, withInterceptors, withInterceptorsFromDi, withJsonpSupport} from "@angular/common/http";
import {ApplicationConfig, importProvidersFrom} from '@angular/core';
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from "@angular/material/form-field";
import { MAT_SELECT_CONFIG } from '@angular/material/select';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {provideRouter} from '@angular/router';
import {AdminPortalAppConfigService} from "@app/config/admin-portal-app-config.service";
import {AdminContextService} from "@app/security/admin-context.service";
import {environment} from "@env/environment";
import {AppConfigService} from "@ui-kit/config/app-config.service";
import {CurrentContextService} from "@ui-kit/security/service/current-context.service";
import {networkInterceptorFn} from "projects/nter-ui-kit/src/lib/framework/interceptor/network-interceptor.service";
import {tokenInterceptorFn} from "src/app/interceptors/token-interceptor.service";
import {unauthenticatedAccessInterceptorFn} from "src/app/interceptors/unauthenticated-access-interceptor.service";

import {routes} from './app.routes';
import { MAT_CARD_CONFIG } from "@angular/material/card";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(
      withInterceptorsFromDi(),
      withJsonpSupport(),
      withInterceptors([tokenInterceptorFn, unauthenticatedAccessInterceptorFn, networkInterceptorFn])
    ),
    {provide: AppConfigService, useClass: AdminPortalAppConfigService},
    {provide: CurrentContextService, useClass: AdminContextService},
    {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {subscriptSizing: 'dynamic', appearance: 'outline'}},
    {provide: MAT_SELECT_CONFIG, useValue: {overlayPanelClass: 'compact-select-panel'}},
    {provide: MAT_CARD_CONFIG, useValue: {appearance: 'outlined'}},
    importProvidersFrom(MatGoogleMapsAutocompleteModule.forRoot(environment.googleMapsApiKey)),
  ]
};
